import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b82f5600"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_lookup_clone",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "newTargetCloneModalRef",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-100 mw-lg-50" }
const _hoisted_3 = { class: "modal-content mx-md-15" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy fs-3 text-primary" })
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "6",
      y: "17.3137",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-45 6 17.3137)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "7.41422",
      y: "6",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(45 7.41422 6)",
      fill: "black"
    })
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body py-lg-5 px-lg-7 mh-700px scroll-y bg-light" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle table-row-bordered mb-0 fs-6 min-w-300px" }
const _hoisted_11 = { class: "fw-bold text-gray-600" }
const _hoisted_12 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "2"
}
const _hoisted_13 = { class: "d-block mb-2" }
const _hoisted_14 = { class: "required" }
const _hoisted_15 = { class: "fv-plugins-message-container text-start" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "1"
}
const _hoisted_18 = { class: "d-block mb-2" }
const _hoisted_19 = { class: "required" }
const _hoisted_20 = { class: "fv-plugins-message-container text-start" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = {
  class: "text-muted ps-5 min-w-125px",
  colspan: "1"
}
const _hoisted_23 = { class: "d-block" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "fv-plugins-message-container text-start" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = {
  class: "text-muted",
  colspan: "2"
}
const _hoisted_28 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_29 = { class: "accordion-item" }
const _hoisted_30 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_4"
}
const _hoisted_31 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_4",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_1_body_4"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box me-2 fs-4 text-primary" })
  ])
], -1))
const _hoisted_33 = {
  id: "kt_accordion_1_body_4",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_4",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_34 = { class: "accordion-body" }
const _hoisted_35 = { class: "table-responsive" }
const _hoisted_36 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_37 = { class: "fw-bold text-muted" }
const _hoisted_38 = { class: "w-50px" }
const _hoisted_39 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_40 = ["checked"]
const _hoisted_41 = { class: "min-w-150px text-uppercase" }
const _hoisted_42 = { class: "min-w-140px text-uppercase" }
const _hoisted_43 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_44 = ["checked", "onClick"]
const _hoisted_45 = { class: "d-flex align-items-center" }
const _hoisted_46 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_47 = { class: "text-dark text-hover-primary fs-6" }
const _hoisted_48 = { class: "text-dark text-hover-primary d-block fs-6" }
const _hoisted_49 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_50 = ["data-kt-indicator"]
const _hoisted_51 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_52 = { class: "svg-icon svg-icon-3 me-0" }
const _hoisted_53 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddAddressModal = _resolveComponent("AddAddressModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_modal_new_target_form",
          onSubmit: _ctx.submitCloneData,
          ref: "cloneLookupRef",
          class: "form",
          "validation-schema": _ctx.cloneLookupData.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.translate("common.clone")) + " - " + _toDisplayString(_ctx.lookupObj?.lookupName), 1)
              ]),
              _createElementVNode("div", {
                class: "btn btn-sm btn-icon btn-active-color-primary",
                "data-bs-dismiss": "modal",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args)), ["stop"]))
              }, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("tbody", _hoisted_11, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.translate("common.name")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "lookupName",
                          autocomplete: "off",
                          modelValue: _ctx.cloneTargetData['lookupName'],
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cloneTargetData['lookupName']) = $event)),
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_ErrorMessage, { name: "lookupName" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.translate("common.startDate")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          name: "startDate",
                          modelValue: _ctx.cloneTargetData['startDate'],
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cloneTargetData['startDate']) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Datepicker, _mergeProps({
                              placeholder: _ctx.translate('common.selectDate'),
                              modelValue: _ctx.cloneTargetData['startDate'],
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cloneTargetData['startDate']) = $event)),
                              enableTimePicker: false,
                              format: _ctx.displayDate,
                              "model-type": "yyyy-MM-dd",
                              autoApply: true
                            }, field, {
                              "min-date": _ctx.minDate,
                              teleport: "body"
                            }), null, 16, ["placeholder", "modelValue", "format", "min-date"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_ErrorMessage, { name: "startDate" })
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.translate("common.endDate")), 1)
                        ]),
                        _createVNode(_component_Field, {
                          name: "endDate",
                          modelValue: _ctx.cloneTargetData['endDate'],
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cloneTargetData['endDate']) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Datepicker, _mergeProps({
                              placeholder: _ctx.translate('common.selectDate'),
                              modelValue: _ctx.cloneTargetData['endDate'],
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cloneTargetData['endDate']) = $event)),
                              enableTimePicker: false,
                              format: _ctx.displayDate,
                              "model-type": "yyyy-MM-dd",
                              autoApply: true
                            }, field, {
                              "min-date": _ctx.minEndDate,
                              teleport: "body"
                            }), null, 16, ["placeholder", "modelValue", "format", "min-date"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_ErrorMessage, { name: "endDate" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("h2", _hoisted_30, [
                              _createElementVNode("button", _hoisted_31, [
                                _hoisted_32,
                                _createTextVNode(" " + _toDisplayString(_ctx.translate("pages.lookup.lookupDataModel")), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("table", _hoisted_36, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", _hoisted_37, [
                                        _createElementVNode("th", _hoisted_38, [
                                          _createElementVNode("div", _hoisted_39, [
                                            _createElementVNode("input", {
                                              class: "form-check-input",
                                              type: "checkbox",
                                              value: "",
                                              checked: 
                                              _ctx.cloneTargetData?.cloneDataModel
                                                ?.length > 0 &&
                                              _ctx.cloneTargetData?.cloneDataModel
                                                ?.length ==
                                                _ctx.cloneLookupData?.cloneDataModel
                                                  ?.length
                                            ,
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (
                                              _ctx.selectAll(
                                                $event,
                                                'cloneDataModel'
                                              )
                                            ))
                                            }, null, 8, _hoisted_40)
                                          ])
                                        ]),
                                        _createElementVNode("th", _hoisted_41, _toDisplayString(_ctx.translate("pages.lookup.code")), 1),
                                        _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.translate("common.text")), 1)
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloneLookupData.cloneDataModel, (model, index) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                          _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_43, [
                                              _createElementVNode("input", {
                                                type: "checkbox",
                                                class: "form-check-input",
                                                value: "",
                                                checked: 
                                                _ctx.isChecked(
                                                  'cloneDataModel',
                                                  model.webId
                                                )
                                              ,
                                                onClick: ($event: any) => (
                                                _ctx.updateCloneArray(
                                                  $event,
                                                  model.webId,
                                                  'cloneDataModel'
                                                )
                                              )
                                              }, null, 8, _hoisted_44)
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_45, [
                                              _createElementVNode("div", _hoisted_46, [
                                                _createElementVNode("span", _hoisted_47, _toDisplayString(model.code), 1)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("td", null, [
                                            _createElementVNode("span", _hoisted_48, _toDisplayString(model.text), 1)
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("button", {
                type: "reset",
                id: "site_clone_cancel",
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                "data-bs-dismiss": "modal",
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.$emit('on-cancel')), ["stop"]))
              }, _toDisplayString(_ctx.translate("common.close")), 1),
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                type: "submit"
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate("common.save")), 1),
                      _createElementVNode("span", _hoisted_52, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                      _createTextVNode(_toDisplayString(_ctx.translate("common.pleaseWait")) + " ", 1),
                      _hoisted_54
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_50)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createVNode(_component_AddAddressModal, {
      showModal: _ctx.showAddressModal,
      data: _ctx.cloneTargetData['address'],
      "onUpdate:modelValue": _ctx.updateShowModalVal,
      isEditable: _ctx.isEditMode,
      onSubmit: _ctx.addressSubmit
    }, null, 8, ["showModal", "data", "onUpdate:modelValue", "isEditable", "onSubmit"])
  ], 512))
}